module.exports = __webpack_public_path__ + "media/images/logo_fjnext-87cc57cdc87743f825536fc6b7e9b794.png";